// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const Environment = {
  Local: {
    production: false,
    /**
     * GraphQL server Endpoint URL
     */
    PropertyPlatformGQLHost: "http://localhost:5110/propertyxplatform",
    Property365CrmApiHost: "https://demop365api.property365.my",
    GoogleApiKey: "AIzaSyAjLHpeTRaaHTL1dZ5NEHIQ42ADxvVVGHE",
    DisableLoader: false,
    DateFormat: "DD MMM YYYY, hh:mm:A",
    InputDateFormat: "DD/MM/YYYY",
    InputDateTimeFormat: "DD/MM/YYYY HH:mm:ss",
    tinyMceApiKey: 'o0o3jt3p012xq8n7jtkzis20ihi3ugxc7ilgbwyd4evfnmat',
    PasswordPublicKey: `
    -----BEGIN PUBLIC KEY-----
    MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCYew+xTQWimCKAaLKuVXEptqcL
    d+jF8046lyrn8Ow8+fCuWZlLnrdeAcjMyyFsQ+PS6nJnPTGtXFiEdUQ9elPPqYrx
    xnMS4pZxDuuq75Y9hEL4HsYON1+5gVQNJuv/xhGxXq6nmjE5aSOeMQq1fcralcdK
    P90sJSdGAZpiNNYSLwIDAQAB
    -----END PUBLIC KEY-----`,
  },
  Dev: {
    production: false,
    /**
     * GraphQL server Endpoint URL
     */
    PropertyPlatformGQLHost:
      "https://platform-api-dev-property.ifca.io/propertyxplatform",
    Property365CrmApiHost: "https://demop365api.property365.my",
    GoogleApiKey: "AIzaSyAjLHpeTRaaHTL1dZ5NEHIQ42ADxvVVGHE",
    DisableLoader: false,
    DateFormat: "DD MMM YYYY, hh:mm:A",
    InputDateFormat: "DD/MM/YYYY",
    InputDateTimeFormat: "DD/MM/YYYY HH:mm:ss",
    tinyMceApiKey: 'o0o3jt3p012xq8n7jtkzis20ihi3ugxc7ilgbwyd4evfnmat',
    PasswordPublicKey: `
    -----BEGIN PUBLIC KEY-----
    MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCYew+xTQWimCKAaLKuVXEptqcL
    d+jF8046lyrn8Ow8+fCuWZlLnrdeAcjMyyFsQ+PS6nJnPTGtXFiEdUQ9elPPqYrx
    xnMS4pZxDuuq75Y9hEL4HsYON1+5gVQNJuv/xhGxXq6nmjE5aSOeMQq1fcralcdK
    P90sJSdGAZpiNNYSLwIDAQAB
    -----END PUBLIC KEY-----`,
  },
  Uat: {
    production: false,
    /**
     * GraphQL server Endpoint URL
     */
    PropertyPlatformApiHost:
      "https://platform-api-uat-property.ifca.io/propertyxplatform",
    PropertyPlatformGQLHost:
      "https://platform-indo-api-demo.ifca.io/propertyxplatform",
    Property365CrmApiHost: "https://demop365api.property365.my",
    GoogleApiKey: "AIzaSyAjLHpeTRaaHTL1dZ5NEHIQ42ADxvVVGHE",
    DisableLoader: false,
    DateFormat: "DD MMM YYYY, hh:mm:A",
    InputDateFormat: "DD/MM/YYYY",
    InputDateTimeFormat: "DD/MM/YYYY HH:mm:ss",
    tinyMceApiKey: 'o0o3jt3p012xq8n7jtkzis20ihi3ugxc7ilgbwyd4evfnmat',
    PasswordPublicKey: `
    -----BEGIN PUBLIC KEY-----
    MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCYew+xTQWimCKAaLKuVXEptqcL
    d+jF8046lyrn8Ow8+fCuWZlLnrdeAcjMyyFsQ+PS6nJnPTGtXFiEdUQ9elPPqYrx
    xnMS4pZxDuuq75Y9hEL4HsYON1+5gVQNJuv/xhGxXq6nmjE5aSOeMQq1fcralcdK
    P90sJSdGAZpiNNYSLwIDAQAB
    -----END PUBLIC KEY-----`,
  },
  Prod: {
    production: false,
    /**
     * GraphQL server Endpoint URL
     */
    PropertyPlatformApiHost:
      "https://platform-api.property-x.asia/propertyxplatform",
    Property365CrmApiHost: "https://p365api.property365.my",
    GoogleApiKey: "AIzaSyAjLHpeTRaaHTL1dZ5NEHIQ42ADxvVVGHE",
    DisableLoader: false,
    DateFormat: "DD MMM YYYY, hh:mm:A",
    InputDateFormat: "DD/MM/YYYY",
    InputDateTimeFormat: "DD/MM/YYYY HH:mm:ss",
    tinyMceApiKey: 'o0o3jt3p012xq8n7jtkzis20ihi3ugxc7ilgbwyd4evfnmat',
    PasswordPublicKey: `
    -----BEGIN PUBLIC KEY-----
    MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCYew+xTQWimCKAaLKuVXEptqcL
    d+jF8046lyrn8Ow8+fCuWZlLnrdeAcjMyyFsQ+PS6nJnPTGtXFiEdUQ9elPPqYrx
    xnMS4pZxDuuq75Y9hEL4HsYON1+5gVQNJuv/xhGxXq6nmjE5aSOeMQq1fcralcdK
    P90sJSdGAZpiNNYSLwIDAQAB
    -----END PUBLIC KEY-----`,
  },
};

export const environment = Environment.Dev;
